module.exports = __webpack_public_path__ + "img/Signature.84428edf.svg";